<template>
    <div class="form-group text">
        <label
            class="control-label"
            :for="name"
            v-text="overrideDynamicLabel ? label : countryData.postCode.term"
        ></label>
        <input
            v-validate="'required'"
            class="form-control"
            :id="name"
            @input="formatInput"
            :maxlength="countryData.postCode.maxLength"
            :minlength="countryData.postCode.minLength"
            :name="name"
            type="text"
            required="required"
            v-model="postCode"
        >
        <small
            v-show="vErrors.has(name)"
            class="text-danger">
            {{ vErrors.first(name) }}
        </small>
    </div>
</template>

<script>
import {CountryData} from "../../../../config";

export default {
    name: 'PostCodeInput',

    inject: {
        $validator: '$validator'
    },

    props: {
        country: {
            default: CountryData.GBR.name,
            required: false,
            type: String,
        },
        label: {
            default: CountryData.GBR.postCode.term,
            required: false,
            type: String,
        },
        name: {
            default: 'address_zip',
            required: false,
            type: String,
        },
        overrideDynamicLabel: {
            default: false,
            required: false,
            type: Boolean,
        },
        value: {
            default: '',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            postCode: `${this.value}`,
        }
    },

    computed: {
        countryData() {
            return Object.values(CountryData).find(country => country.name === this.country);
        },
    },

    watch: {
        postCode(newVal) {
            this.$emit('input', newVal);
        },
        country: function (newVal) {
            this.postCode = newVal != 'United Kingdom' ? this.postCode.replace(/\s/g, "") : this.postCode;
        }
    },

    methods: {
        formatInput(event) {
            //We should really be checking the formatting requirements of the country data
            if (this.country !== 'United Kingdom' && event.keyCode === 32) {
                event.preventDefault();
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/PostCodeInput.vue